






































































import ALPage from '@/components/core/Page/ALPage.vue';
import Vue from 'vue';
export default Vue.extend({
  name: 'ItemTranslationListPage',

  data() {
    return {
      search: '',
      next: '',
      previous: '',
      totalItems: 0,
      csiTranslationItems: [],
      dialog: false,
      loading: true,
      options: {
        rowsPerPage: 100
      } as any,
      searchChanged: false,
      headers: [
        { text: 'Part', value: 'identifier', sortable: false },
        { text: 'Language ID', value: 'language', sortable: false },
        { text: 'Description', value: 'text', sortable: false }
      ]
    };
  },
  watch: {
    search(newSearch: string, prevSearch: string) {
      if (newSearch !== prevSearch) {
        this.searchChanged = true;
        this.options.page = 1; //called fetcdata
        this.setData(newSearch);
      }
    },
    options: {
      handler() {},
      deep: true
    }
  },
  methods: {
    updatePage(val: any) {
      if (!this.searchChanged) {
        this.setData(this.search);
      }
    },
    setData(search?: string) {
      return this.fetchDataFromApi(search).then((data: any) => {
        this.csiTranslationItems = data.results;
        this.totalItems = data.count;
      });
    },
    fetchDataFromApi(search?: string) {
      // just save this file if you see no async genterator on promises
      //and no const for count
      this.loading = true;
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        // eslint-disable-next-line prefer-const
        let { results, count } = await this.getCsiItems(search);
        this.searchChanged = false;
        this.loading = false;
        resolve({
          results,
          count
        });
      });
    },
    getCsiItems(search?: string) {
      const { page } = this.options; //data table
      const params = new URLSearchParams();
      params.append('page', page);
      if (search!.length) params.append('search', search!);
      return this.$axios({
        method: 'get',
        url: `/v1/csi/item-translations/`,
        timeout: 5 * (60 * 1000),
        params
      }).then(({ data }: any) => data);
    },
    reopenUpload(err?: any) {
      const upload = (this as any).$refs.uploadfile;
      upload.dialog = true;
    }
  },
  mounted() {
    this.$route.query.search = this.search;
    this.setData(this.search);
  },
  components: { ALPage }
});
